<div class="pd" *ngIf="row as r">
  <!-- Cabecera -->
  <div class="pd-head">
    <div class="pd-head-text">
      <span class="pd-cat" *ngIf="category" [style.color]="category.color"><i [class]="category.icon"></i> {{ category.name }}</span>
      <h2 *ngIf="!editing">{{ r.project.name }}</h2>
      <input *ngIf="editing" class="pd-input pd-input-title" [(ngModel)]="draft.name" placeholder="Nombre del proyecto" />
      <span class="pd-team" *ngIf="r.project.origin === 'proposed' && !editing">
        <i class="fa-solid fa-lightbulb"></i> Iniciativa del equipo interno de TI
      </span>
    </div>
    <!-- El estado lo deriva el backend del trabajo real: no se edita aquí, y en modo edición se
         quedaba flotando al lado del input del título. -->
    <span class="pd-status" *ngIf="!editing" [style.background]="PROJECT_STATUS_META[r.status].color"
      [title]="PROJECT_STATUS_META[r.status].hint">
      <i [class]="PROJECT_STATUS_META[r.status].icon"></i> {{ PROJECT_STATUS_META[r.status].label }}
    </span>
  </div>

  <div class="pd-err" *ngIf="error"><i class="fa-solid fa-triangle-exclamation"></i> {{ error }}</div>

  <!-- Avance del trabajo: solo cuando ya hay épicas. Antes de eso no hay nada que medir. -->
  <div class="pd-work" *ngIf="r.taskCount">
    <div class="pd-work-top">
      <span class="pd-work-lbl"><i class="fa-solid fa-diagram-project" [style.color]="accent"></i> Avance del trabajo</span>
      <span class="pd-work-num">{{ r.doneCount }}/{{ r.taskCount }} tareas · {{ progress }}%</span>
    </div>
    <div class="pd-work-bar"><div class="pd-work-fill" [style.width.%]="progress" [style.background]="accent"></div></div>
    <div class="pd-chips">
      <span class="pd-chip"><i class="fa-solid fa-layer-group"></i> {{ r.epicsAchieved }}/{{ r.epicCount }} épicas conseguidas</span>
      <span class="pd-chip" *ngIf="r.points"><i class="fa-solid fa-weight-hanging"></i> {{ r.points }} pts</span>
    </div>
  </div>

  <!-- Descripción y valor -->
  <div class="pd-block">
    <span class="pd-label"><i class="fa-solid fa-align-left" [style.color]="accent"></i> De qué va</span>
    <p class="pd-text" *ngIf="!editing" [class.muted]="!r.project.description">
      {{ r.project.description || 'Sin descripción todavía — se llena al bajar requerimientos.' }}
    </p>
    <textarea *ngIf="editing" class="pd-input" rows="3" [(ngModel)]="draft.description"
      placeholder="Qué es, en lenguaje no técnico"></textarea>
  </div>

  <div class="pd-block" *ngIf="editing || r.project.value">
    <span class="pd-label"><i class="fa-solid fa-circle-check" [style.color]="accent"></i> Qué aporta</span>
    <p class="pd-text" *ngIf="!editing">{{ r.project.value }}</p>
    <textarea *ngIf="editing" class="pd-input" rows="2" [(ngModel)]="draft.value"
      placeholder="Qué problema resuelve"></textarea>
  </div>

  <!-- Ficha visual. Solo llega marcada para Admin: el backend no expone `hasShowcase` a nadie más
       porque la ficha lleva lo que costaría desarrollar el proyecto por fuera. -->
  <div class="pd-block pd-ficha" *ngIf="r.hasShowcase || editing">
    <span class="pd-label"><i class="fa-solid fa-image" [style.color]="accent"></i> Ficha visual</span>

    <ng-container *ngIf="r.hasShowcase; else sinFicha">
      <div class="pd-ficha-row">
        <a class="pd-ficha-open" [routerLink]="['/roadmap/proyecto', r.project.slug]">
          <i class="fa-solid fa-arrow-up-right-from-square"></i> Abrir la ficha
        </a>
        <span class="pd-ficha-when" *ngIf="r.showcaseUpdatedAt">
          Actualizada el {{ r.showcaseUpdatedAt | date: 'd MMM y' }}
        </span>
        <button type="button" class="pd-drop" *ngIf="editing" (click)="dropShowcase()" title="Quitar la ficha">
          <i class="fa-solid fa-xmark"></i>
        </button>
      </div>
    </ng-container>
    <ng-template #sinFicha>
      <p class="pd-text muted">
        Sin ficha. Se redacta y se carga desde una sesión con <code>/proyecto-ficha {{ r.project.slug }}</code>.
      </p>
    </ng-template>
  </div>

  <!-- Entregables -->
  <div class="pd-block">
    <span class="pd-label">
      <i class="fa-solid fa-list-check" [style.color]="accent"></i> Entregables
      <span class="pd-count" *ngIf="r.deliverablesTotal">{{ r.deliverablesDone }}/{{ r.deliverablesTotal }}</span>
    </span>

    <ng-container *ngIf="!editing">
      <ul class="pd-deliverables" *ngIf="r.project.deliverables?.length; else sinEntregables">
        <li *ngFor="let d of r.project.deliverables" [class.done]="d.done">
          <i class="fa-solid" [ngClass]="d.done ? 'fa-square-check' : 'fa-square'" [style.color]="d.done ? accent : '#cbd5e1'"></i>
          <span>{{ d.title }}</span>
        </li>
      </ul>
      <ng-template #sinEntregables>
        <p class="pd-text muted">Sin entregables definidos. Es lo que convierte una idea en un proyecto aterrizado.</p>
      </ng-template>
    </ng-container>

    <ng-container *ngIf="editing">
      <ul class="pd-deliverables editable">
        <li *ngFor="let d of deliverables; let i = index">
          <input type="checkbox" [(ngModel)]="d.done" [attr.aria-label]="'Marcar ' + d.title" />
          <input class="pd-input pd-input-inline" [(ngModel)]="d.title" />
          <button type="button" class="pd-drop" (click)="dropDeliverable(i)" [attr.aria-label]="'Quitar ' + d.title">
            <i class="fa-solid fa-xmark"></i>
          </button>
        </li>
      </ul>
      <div class="pd-add">
        <input class="pd-input" [(ngModel)]="nuevoEntregable" placeholder="Nuevo entregable"
          (keydown.enter)="addDeliverable()" />
        <button type="button" class="pd-add-btn" (click)="addDeliverable()"><i class="fa-solid fa-plus"></i></button>
      </div>
    </ng-container>
  </div>

  <!-- Comercial. Solo existe en la respuesta si quien mira es Admin: si no llegó, ni se insinúa. -->
  <div class="pd-block pd-commercial" *ngIf="canEditPrice">
    <span class="pd-label"><i class="fa-solid fa-tag" [style.color]="accent"></i> Comercial</span>

    <ng-container *ngIf="!editing">
      <div class="pd-money" *ngIf="priceLabel() as precio; else sinPrecio">
        <span class="pd-money-val">{{ precio }}</span>
        <span class="pd-money-state" [style.color]="COMMERCIAL_STATUS_META[r.project.commercial!.status].color">
          {{ COMMERCIAL_STATUS_META[r.project.commercial!.status].label }}
        </span>
        <span class="pd-money-client" *ngIf="r.project.commercial!.client">
          <i class="fa-regular fa-building"></i> {{ r.project.commercial!.client }}
        </span>
      </div>
      <ng-template #sinPrecio><p class="pd-text muted">Sin precio. Los proyectos internos no lo llevan.</p></ng-template>
      <p class="pd-text pd-notes" *ngIf="r.project.commercial?.notes">{{ r.project.commercial!.notes }}</p>
    </ng-container>

    <ng-container *ngIf="editing">
      <button type="button" class="pd-add-btn wide" *ngIf="!draft.commercial" (click)="startCommercial()">
        <i class="fa-solid fa-plus"></i> Agregar información comercial
      </button>
      <div class="pd-grid" *ngIf="draft.commercial as c">
        <label>Precio<input class="pd-input" type="number" min="0" [(ngModel)]="c.price" placeholder="0" /></label>
        <label>Cliente<input class="pd-input" [(ngModel)]="c.client" placeholder="Interno si se deja vacío" /></label>
        <label>Situación
          <p-dropdown [options]="COMMERCIAL_STATUSES" [(ngModel)]="c.status" optionLabel="label" optionValue="value"
            appendTo="body" styleClass="pd-dd"></p-dropdown>
        </label>
        <label class="pd-check"><input type="checkbox" [(ngModel)]="c.withVat" /> El precio ya incluye IVA</label>
        <label class="pd-wide">Notas<textarea class="pd-input" rows="2" [(ngModel)]="c.notes"></textarea></label>
      </div>
    </ng-container>
  </div>

  <!-- Categoría, fecha e ícono -->
  <ng-container *ngIf="editing">
    <div class="pd-grid">
      <label>Categoría
        <p-dropdown [options]="CATEGORIES" [(ngModel)]="draft.category" optionLabel="name" optionValue="id"
          appendTo="body" styleClass="pd-dd"></p-dropdown>
      </label>
      <label>Fecha objetivo<input class="pd-input" [(ngModel)]="draft.targetDate" placeholder="Sep 2026 · 2026-Q4" /></label>
    </div>

    <!-- El ícono se ELIGE. Antes era un input donde había que teclear la clase de FontAwesome de
         memoria: quien registra un proyecto no tiene por qué conocer ese catálogo. -->
    <div class="pd-icons">
      <span class="pd-icons-lbl">Ícono</span>
      <div class="pd-icons-grid">
        <button type="button" class="pd-icon" *ngFor="let o of ICONS" [class.on]="draft.icon === o.icon"
          [style.--pd-accent]="accent" [title]="o.label" (click)="draft.icon = o.icon">
          <i [class]="o.icon"></i>
        </button>
      </div>
    </div>
  </ng-container>

  <div class="pd-foot">
    <span class="pd-date" [class.muted]="!r.project.targetDate">
      <i class="fa-regular fa-calendar"></i>
      {{ r.project.targetDate ? 'Objetivo: ' + r.project.targetDate : 'Sin fecha objetivo' }}
    </span>
    <div class="pd-links" *ngIf="r.project.links?.length">
      <button type="button" class="pd-link" *ngFor="let l of r.project.links" (click)="copyRef(l)"
        [title]="'Copiar la ruta: ' + l.ref">
        <i [class]="copied === l.ref ? 'fa-solid fa-check' : linkIcon(l)"></i>{{ copied === l.ref ? 'Ruta copiada' : l.label }}
      </button>
    </div>
  </div>

  <!-- Acciones -->
  <div class="pd-actions">
    <ng-container *ngIf="!editing">
      <button type="button" class="pd-btn primary" (click)="startEdit()"><i class="fa-solid fa-pen"></i> Editar</button>
      <!-- Retirar solo cuando no cuelga nada: el backend se niega igual, pero enseñar un botón que
           siempre falla es peor que no enseñarlo. -->
      <button type="button" class="pd-btn danger" *ngIf="!r.epicCount" (click)="remove.emit()">
        <i class="fa-solid fa-box-archive"></i> Retirar
      </button>
    </ng-container>
    <ng-container *ngIf="editing">
      <button type="button" class="pd-btn" (click)="cancelEdit()" [disabled]="saving">Cancelar</button>
      <button type="button" class="pd-btn primary" (click)="onSave()" [disabled]="saving">
        <i class="fa-solid" [ngClass]="saving ? 'fa-spinner fa-spin' : 'fa-check'"></i> Guardar
      </button>
    </ng-container>
  </div>
</div>
